import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const RegistrationClass = ({ registrationClass }: SpecProps<"registration_class">) => {
  const { i18n } = useLingui();

  if (!registrationClass) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.registration_class",
    message: "Registration class",
    comment: "Field for 'registration class' in ad specification",
  });
  return <FieldValuePair field={field} value={registrationClass} />;
};
